import { getToken } from '../Context/User.context';
import API from './index';

export const getAircraft = () => API.get('/aircraft', {headers: { "Authorization": `Bearer ${getToken()}`}});
